/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Input_Position_Vertical_Text_TitleInputs */



/**
* | output |
* | --- |
* | "Vertical Text" |
*
* @param {Input_Position_Vertical_Text_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const input_position_vertical_text_title = /** @type {((inputs?: Input_Position_Vertical_Text_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Input_Position_Vertical_Text_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Texte Vertical")
	if (locale === "de") return /** @type {LocalizedString} */ ("Vertikaler Text")
	if (locale === "it") return /** @type {LocalizedString} */ ("Testo verticale")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Вертикальный текст")
	if (locale === "es") return /** @type {LocalizedString} */ ("Texto vertical")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("竖文本")
	if (locale === "ja") return /** @type {LocalizedString} */ ("縦書きテキスト")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ऊर्ध्वाधर पाठ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Texto vertical")
	return /** @type {LocalizedString} */ ("Vertical Text")
});